/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Presentation_Design_TemplatesInputs */



/**
* | output |
* | --- |
* | "Templates" |
*
* @param {Presentation_Design_TemplatesInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_design_templates = /** @type {((inputs?: Presentation_Design_TemplatesInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Design_TemplatesInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Vorlagen")
	return /** @type {LocalizedString} */ ("Templates")
});